/**
 * @file RecentNews 组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect} from 'react';
import {Row, Col} from 'antd';
import {useHistory} from 'react-router-dom';
import moment from 'moment';
import Item from '~/component/PastEvents/Item';
import BaseCard from '~/component/BaseCard';

import './index.less';

function RecentNews({data}) {
    const history = useHistory();
    const dataList = data?.slice(0, 4);

    function handleClick() {
        history.push('/news/releases');
    }

    function handleDetail(id) {
        // 爬虫获取的新闻，参数用id
        history.push(`/news/detail/${id}?type=news`);
    }
    return (
        <div className="recent-container">
            <BaseCard title="Recent News" onClick={handleClick} isConfig>
                <Row>
                    {!!dataList
                        && dataList.map(({id, title, publishTime}) => (
                            <Col
                                key={id}
                                span={12}
                                // eslint-disable-next-line react/jsx-no-bind
                                onClick={() => handleDetail(id)}
                            >
                                <Item
                                    title={title}
                                    time={`${moment(publishTime).format('MMMM Do YYYY')}`}
                                />
                            </Col>
                        ))}
                </Row>
            </BaseCard>
        </div>
    );
}

export default RecentNews;
